import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CollectionService} from '../../Services/collection.service';
import {CollectionDiscount} from '../../Models/CollectionDiscount';
import {DealersService} from '../../Services/dealers.service';
import {InvoiceDealer} from '../../Models/InvoiceDealer';

@Component({
  selector: 'app-collection-discount',
  templateUrl: './collection-discount.component.html',
  styleUrls: ['./collection-discount.component.scss']
})
export class CollectionDiscountComponent implements OnInit {

  public collections = [];
  public collectionItems = [];
  @Input() showModal = false;
  @Input() isEdit = false;
  @Input() invoiceDealerId;
  @Input() collectionDiscounts: CollectionDiscount[];
  @Output('closeModal') closeModal = new EventEmitter<{ closeModal: boolean, refreshData: boolean }>();
  @ViewChild('addDiscountModal', {static: true}) addDiscountModal;

  constructor(
    private collectionService: CollectionService,
    private dealersService: DealersService) {
  }

  ngOnInit() {
    this.showCollectionDiscountModal();
  }

  showCollectionDiscountModal() {
    if (this.isEdit) {
      this.collectionDiscounts.map(collectionDiscount => {
        collectionDiscount.collection = collectionDiscount.collection.id;
        collectionDiscount.discount = parseFloat((collectionDiscount.discount.toString()));
      });
    } else {
      this.addCollectionDiscountItem();
    }
    this.collectionService.getCollection().subscribe(res => {
      this.collections = [];
      res.data.map(collection => {
        this.collectionItems.push({
          label: collection.name,
          value: collection.id
        });
        this.collections = Object.assign([], this.collectionItems);
      });
    });
    this.addDiscountModal.show();
  }

  hideCollectionDiscountModal() {
    this.showModal = false;
    this.addDiscountModal.hide();
    this.closeModal.emit({
      closeModal: this.showModal,
      refreshData: false
    });
  }

  addCollectionDiscountItem() {
    this.collectionDiscounts.push(new CollectionDiscount());
  }

  removeCollectionDiscountItem(i) {
    this.collectionDiscounts.splice(i, 1);
    this.collectionDiscounts = JSON.parse(JSON.stringify(this.collectionDiscounts));
  }

  SaveDiscounts() {
    const dealer = new InvoiceDealer();
    dealer.collectionDiscounts = JSON.parse(JSON.stringify(this.collectionDiscounts));
    this.dealersService.manageDealerCollectionDiscount(this.invoiceDealerId, dealer).subscribe(res => {
      this.showModal = false;
      this.addDiscountModal.hide();
      this.closeModal.emit({
        closeModal: this.showModal,
        refreshData: true
      });
    });
  }

  getCollections(collectionDiscountModel) {
    this.collections.map(collection => {
      collection.disabled = false;
    });

    this.collectionDiscounts.forEach(collectionDiscount => {
      this.collections.forEach(c => {
        if (c.value === collectionDiscount.collection && c.value !== collectionDiscountModel) {
          c.disabled = true;
        }
      });
    });
    return this.collections;
  }
}
